import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/BlogArticlePage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Now that hooks have been released for... 🤔`}<em parentName="p">{`checks watch`}</em>{` ...less than two months, you've probably noticed there are a few obvious wins if you've been using them, like:`}</p>
    <ul>
      <li parentName="ul">{`Hooks takes less code to achieve the same thing compared to classes`}</li>
      <li parentName="ul">{`No weird issues with `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`this`}</code></li>
      <li parentName="ul">{`Less complex update strategy vs. `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`componentDidUpdate()`}</code></li>
    </ul>
    <p>{`There are some other wins that might not stand out right away, and one very important win is grouping related code.`}</p>
    <p>{`Let me explain...`}</p>
    <p>{`Class-based components encouraged us to group code based on lifecycle methods instead of features. Let's say we want to get a user from the network and we also want to subscribe to a browser window event. With classes, the user-based state is mixed with the window subscription state. The user-based setup is in the same method as the window subscription setup. We didn't `}<em parentName="p">{`need`}</em>{` these to be mixed, it's just what we have to do when we group code based on lifecycles.`}</p>
    <p>{`With hooks we can group code by feature instead (blue for user stuff, green for subscription stuff):`}</p>
    <undefined><p {...{
        "style": {
          "textAlign": "center"
        }
      }}>{`
  `}<img parentName="p" {...{
          "src": "/b9781a3d347cfc8cb914bca9872a1299/animation.gif",
          "alt": "Animating Class-Based component to Hooks-Based Component"
        }}></img>{`
`}</p>
      <div {...{
        "className": "align-center text-small"
      }}>{`Animation made with Apple's Keynote`}</div></undefined>
    <hr />
    <p>{`Now with code grouped by feature, it's easy to see that some of our code can be abstracted into a custom hook, like we did in the animation with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useScrollPosition`}</code>{`.`}</p>
    <p>{`Before hooks, we might have used an `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/higher-order-components.html"
      }}>{`HoC`}</a>{` or a `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/render-props.html"
      }}>{`Render Prop`}</a>{` pattern to re-use scroll logic. Each of those patterns has well-documented trade-offs but hooks seem to give us the best aspects of these older patterns while avoiding their pitfalls.`}</p>
    <p>{`That's it. Happy coding.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      